export default __webpack_public_path__ + "static/media/zend-framework.04a3c9a7.svg";